import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Cta extends Component {
    render() {
        return (
            <section className="banner-2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-content">
                                <h2 className="text-custom-white">Find Opportunites to Work with World Lead Companies</h2>
                                <p>Our site offer 100% free resource for candidates looking to work in world's lead companies across the globe. No fees, no markups, no middlemen.</p>
                                <Link to="/contact" className="btn-first btn-small">Get Started</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Cta;